<template>
    <div @click="clickHandler" :class="className" style="cursor: pointer;" :data-href="link">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'link-wrapper',

    props: {
        link: {
            type: String,
        },

        className: {
            type: String,
        },
    },

    methods: {
        clickHandler() {
            if (!this.link) return;

            window.location = this.link;
        },
    },
};
</script>
